<template>
  <div class="manClass">
    <div class="title">
      <h2>班级管理</h2>
    </div>
    <div class="sea">
      <span>班级列表</span>
      <div class="mod">
        <a-select
          class="selbtn"
          allow-clear
          placeholder="课程名称"
          :notFoundContent="'暂无数据'"
          @change="indexSelect"
          v-decorator="['modelname',{rules:[{required:true,message:'请选择课程名称'}]}]"
        >
          <a-select-option
            v-for="(item,index) in classlist"
            :key="index"
            :value="item.id"
          >
            {{item.title}}
          </a-select-option>
        </a-select>
      </div>
      <input
        type="text"
        placeholder="请输入关键字"
        v-model="key"
      >
      <button
        class="ban"
        @click="searchbtn"
      >搜索</button>
      <button
        class="addbtn"
        @click="addbtn"
      >新增</button>
    </div>
    <ul class="list">
      <a-empty
        class="empty"
        v-if="list.length==0"
        description="暂无此数据"
      />
      <li
        v-else
        v-for="item in list"
        :key="item.id"
      >
        <p class="tit">{{item.title}}</p>
        <p class="cou" :title="item.course.title">
          <img src="../../assets/mine/sub.png" alt="">
          课程：{{item.course.title}}
        </p>
        <p class="stu">
           <img src="../../assets/mine/num.png" alt="">
          学生：<span>{{item.studentNum}}人</span>
        </p>
        <div class="oper">
          <span
            class="modify"
            @click="changeclass(item.id,item.title)"
          ></span>
          <span
            class="del"
            @click="delclass(item.id,item.title)"
          ></span>
        </div>
        <p class="view">
          <span
            class="manview"
            @click="tomanstudent(item.id)"
          >学生管理</span>
          <span
            class="stuayview"
            @click="tostudyview(item.id)"
          >学情查看</span>
        </p>
      </li>
    </ul>

    <!-- 新增 -->
    <a-modal
      title="新增班级"
      :visible="addshow"
      @ok="handleOk"
      @cancel="addcancel"
      class="addclassmodal"
      okText="确认"
      cancelText="取消"
    >
      <eform
        :formData="formDate"
        class="form"
        ref="form"
      >
        <div slot="name">
          <a-input
            v-decorator="['name',{rules: [{ required: true, message: ' 请输入班级名称' }]}]"
            class="input"
          />
        </div>
        <div slot="subject">
          <a-select
            class="selbtn"
            allow-clear
            placeholder="请选择所属课程"
            :notFoundContent="'暂无数据'"
            @change="Select"
            v-decorator="['subject',{rules:[{required:true,message:'请选择所属课程'}]}]"
          >
            <a-select-option
              v-for="(item,index) in classlist"
              :key="index"
              :value="item.id"
            >
              {{item.title}}
            </a-select-option>
          </a-select>
        </div>
      </eform>

    </a-modal>

    <!-- 修改 -->
    <a-modal
      title="修改班级名"
      :visible="recshow"
      @ok="recOk"
      @cancel="recancel"
      :destroyOnClose="true"
      class="addclassmodal"
      okText="确认"
      cancelText="取消"
    >
      <eform
        :formData="formrect"
        class="form"
        ref="form"
        :fields="fields"
      >
        <div slot="classTitle">
          <a-input
            v-decorator="['classTitle',{rules: [{ required: true, message: ' 请输入班级名称' }]}]"
            class="input"
          />
        </div>
      </eform>
    </a-modal>
    <div class="pagemodel">
      <pagination
        :pagination="pagination"
        @changePage="changePage"
      ></pagination>
    </div>
  </div>
</template>

<script>
import eform from "@/components/common/form";
import pagination from "@/components/common/pagination";
import {
  getclassListApi,
  getmyCourseListApi,
  getaddclassApi,
  getupdateClassApi,
  getdelclassApi,
} from "@/request/api";
export default {
  name: "manClass",
  components: { eform, pagination },
  data() {
    const formDate = [
      {
        label: "班级名称",
        scopedSlots: { customRender: "name" },
      },
      {
        label: "所属课程",
        scopedSlots: { customRender: "subject" },
      },
    ];
    const formrect = [
      {
        label: "班级名称",
        scopedSlots: { customRender: "classTitle" },
      },
    ];
    return {
      addshow: false, 
      fields:null,     
      formDate,
      formrect,
      classlist: [],
      searchInfo: {
        page: 1,
        pageSize: 9,
        keyword: "",
        courseId: "",
      },
      pagination: { total: "", pageSize: 9 },
      list: [],
      key: "",
      classId: "",
      delclassId:'',
      recshow:false
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getToken(getclassListApi, this.searchInfo, (res) => {
        this.pagination.total = res.data.count;
        this.list = res.data.rows;
      });
      this.getToken(getmyCourseListApi, {}, (res) => {
        this.classlist = res.data;
        //  console.log(this.classlist)
      });
    },
    //搜索
    searchbtn() {
      this.searchInfo.keyword = this.key;
      this.init();
    },
    // 新增
    addbtn() {
      this.addshow = true;
    },
    // 新增保存
    handleOk() {
      this.$refs.form.form.validateFields().then((res) => {
        this.getToken(
          getaddclassApi,
          { title: res.name, courseId: res.subject },
          (resquest) => {
            if (resquest.code == 200) {
              this.$message.success("新增成功！");
              this.init();
              this.addshow = false;
            }
          }
        );
      });
    },
    //新增取消
    addcancel() {
      this.$refs.form.form.resetFields(["name"]);
      this.$refs.form.form.resetFields(["subject"]);
      this.addshow = false;
    },
    //下拉筛选
    indexSelect(data) {
      console.log(data)
      this.searchInfo.courseId = data;
      this.init();
    },
    Select() {
      // console.log(data);
    },
    // 学生管理
    tomanstudent( id) {
      this.$router.push({
        path: "/manstudent",
        query: { id },
      });
    },
    //学情管理
    tostudyview( id) {
      this.$router.push({
        path: "/studyview",
        query: { id },
      });
    },
    //分页
    changePage(currentPage) {
      this.searchInfo.page = currentPage;
      this.init();
    },
    //修改班级名
    changeclass(id,title) {
      this.fields={classTitle:title}
      this.recshow = true;
      this.classId =id;
    },
    //确定修改班级名
    recOk() {
      this.$refs.form.form.validateFields().then((res) => {
        this.getToken(getupdateClassApi,{ title: res.classTitle, classId: this.classId },(value) => {
            if (value.code == 200) {
              this.$message.success("修改成功");
              this.$refs.form.form.resetFields(["name"]);
              this.recshow = false;
              this.init();
            }
          }
        );
      });
    },
    //修改取消
    recancel() {
      this.$refs.form.form.resetFields(["name"]);
      this.recshow = false;
    },
    //删除班级名
    delclass(id,title) {
    this.delclassId=id
    this.$confirm({
          title: `确定要删除"${title}"这个班级吗？`,
          okText: '确定',
          cancelText: '取消',
          onOk:()=> {
          this.getToken(getdelclassApi,{ classId:this.delclassId},(res) => {
                if (res.code == 200) {
                  this.init();
                  this.$message.success("删除成功!");
                }
              })
          },
          onCancel() {
            //  console.log('OK');
          },
        });
    },
  },
};
</script>
<style>
.addclassmodal .ant-modal-body {
  padding: 0px;
  font-size: 14px;
  word-wrap: break-word;
  padding-top: 30px;
}
.empty {
  margin: 0 auto;
  /* background:pink; */
  margin-top: 30px;
}
</style>
<style lang="stylus" scoped>
.manClass {
  margin-bottom: 30px;
  .title {
      height: 45px;
      line-height: 45px;
      overflow: hidden;
      border-bottom:1px solid #eff2f2;
      h2 {
        height:45px;
        line-height: 45px;
        margin-left: 30px;
        font-size: 18px;
        font-weight: bold;
        color: #333333;
      }
  }

  .sea {
    height: 45px;
    margin-left: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    position: relative;

    span {
      color: #333;
      font-size: 16px;
      margin-right: 50px;
    }
    .mod {
      width: 204px;
      margin-right: 24px;
      margin-left: 180px;
      .selbtn {
        width: 100%;
        height: 100%;
      }
    }

    input {
      outline: none;
      width: 220px;
      height: 35px;
      border: solid 1px #d4d4d4;
      text-indent: 8px;
    }

    .ban {
      outline: none;
      width: 60px;
      height: 35px;
      background-color: #f1ce48;
      color: #ffffff;
      font-size:14px;
      cursor: pointer;
      border:0
    }

    .addbtn {
      width: 75px;
      height: 35px;
      background-color: #ff904f;
      border-radius: 3px;
      outline: none;
      position: absolute;
      border:0;
      color:#fff;
      font-size:14px;
      top: 50%;
      transform: translateY(-50%);
      right: 40px;
      cursor: pointer;
    }
  }

  .list {
    display: flex;
    margin-top: 50px;
    margin-left: 30px;
    flex-wrap: wrap;

    li {
      border: 1px solid #ddd;
      width: 287px;
      margin-right: 35px;
      margin-bottom: 35px;
      color: #333;
      font-size: 16px;
      position: relative;

      .tit{
        color: #333333;
        display:b
        width:100%;
        font-size:16px;
        margin-top:22px;
        margin-bottom:18px;
        font-weight:bolder;
        padding-left:17px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .cou{
          padding-left:17px;
          color: #666666;
          font-size:14px;
          margin-bottom:9px;
          height:25px;
          line-height 25px;
          width:100%;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          img{
            width:20px;
            hegith:20px;
            margin-top:-3px;
            margin-right:11px;
          }
      }
      .stu{
         padding-left:17px;
         color: #666666;
         font-size:14px;
          height:25px;
          line-height 25px;
          margin-bottom:20px;
         img{
            width:20px;
            hegith:20px;
            margin-top:-3px;
            margin-right:11px;
          }
      }
      .view {
          color: #f1ce48;
          font-size:14px;
          height:35px;
          background-color: #fafafa;
          margin-bottom:0px;
          text-align center;
          line-height :35px;
          display:flex;
          justify-content space-around;
           .manview {
            color: #f1ce48;
            cursor: pointer;
            font-size: 14px;
          }
          .stuayview {
            color: #f1ce48;
            cursor: pointer;
            font-size: 14px;
          }
        }

      .oper {
        width: 70px;
        height:25px;
        position: absolute;
        right: 0px;
        top: 0px;
        display:flex
        align-items center;
        justify-content:space-around
        .modify {
          width:15px;
          height:15px;
          cursor: pointer;
          display:block
          background:url("../../assets/mine/del.png")
        }
        .del {
          width:15px;
          height:15px;
          cursor: pointer;
          display:block
          background:url("../../assets/mine/rec.png")
        }
         .modify:hover {
          background:url("../../assets/mine/del1.png")
        }
        .del:hover{
          background:url("../../assets/mine/rec1.png")
        }
      }

      &:nth-child(3n) {
        margin-right: 0px;
      }
    }
  }

  .pagemodel {
    margin-top: 30px;
  }
}
</style>
